import PrivacyPolicy from '@/assets/puntcity/pdf/privacy_policy.pdf';
import TermsAndConditions from '@/assets/puntcity/pdf/terms_and_conditions.pdf';

export default {
  PrivacyPolicy,
  TermsAndConditions,
};
